export default [
    'titleText',
    'subTitleText',
    'price',
    'titleColor',
    'titlePosition',
    'titleBackgroundColor',
    'subTitlePosition',
    'titleSize',
    'topMargin',
]